module.exports = __webpack_public_path__ + "prod/1.42.2/img/tourism-chain.999f6520.png";